module.exports = __webpack_public_path__ + "media/components/assets/img/pic/smiling-bus-7ef7e0f7015c16cbc5995cd210dec84e.svg";